import { render, staticRenderFns } from "./PreviewLoader.vue?vue&type=template&id=0f475bba&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports